module.exports = __webpack_public_path__ + "img/green-icon-en(2).b871a812.png";